import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { LogOut, User2 } from "lucide-react";
import { LOGO_URL } from "../lib/api";

export const Navbar = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <header
            data-testid="navbar"
            className="fixed top-0 left-0 right-0 z-50 border-b border-zinc-200 bg-white/80 backdrop-blur-xl"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                <Link to="/" data-testid="brand-home" className="flex items-center gap-3">
                    <img src={LOGO_URL} alt="Flexible Workspace Group" className="h-9 w-auto" />
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-sm">
                    <Link data-testid="nav-browse" to="/search" className="text-zinc-700 hover:text-zinc-950 transition-colors">Browse Addresses</Link>
                    <Link data-testid="nav-enroll" to="/enroll" className="text-zinc-700 hover:text-zinc-950 transition-colors">Enroll a Center</Link>
                    {user && (
                        <Link data-testid="nav-dashboard" to="/dashboard" className="text-zinc-700 hover:text-zinc-950 transition-colors">Dashboard</Link>
                    )}
                </nav>

                <div className="flex items-center gap-3">
                    {user ? (
                        <>
                            <div className="hidden sm:flex items-center gap-2 text-xs text-zinc-600">
                                <User2 className="h-4 w-4" strokeWidth={1.5} />
                                <span data-testid="user-email">{user.email}</span>
                                <span className="uppercase text-[10px] tracking-label bg-zinc-100 px-2 py-0.5">{user.user_type}</span>
                            </div>
                            <button
                                data-testid="logout-btn"
                                onClick={async () => { await logout(); navigate("/"); }}
                                className="inline-flex items-center gap-1.5 text-sm text-zinc-700 hover:text-zinc-950"
                            >
                                <LogOut className="h-4 w-4" strokeWidth={1.5} /> Sign out
                            </button>
                        </>
                    ) : (
                        <>
                            <Link
                                data-testid="nav-signin-link"
                                to="/login"
                                className="text-sm text-zinc-700 hover:text-zinc-950"
                            >
                                Sign in
                            </Link>
                            <Link
                                data-testid="nav-register-btn"
                                to="/register"
                                className="bg-zinc-950 text-white px-4 py-2 text-sm font-medium hover:bg-[#FF6A13] transition-colors"
                            >
                                Get started
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </header>
    );
};

export default Navbar;
